import { KeyboardEvent, ReactNode, useCallback } from 'react';

import { MdRefresh } from 'react-icons/md';
import { twMerge } from 'tailwind-merge';

interface ImageUploadInputRetrierProps {
  readonly children?: ReactNode;
  readonly onClick?: () => void;
  readonly className?: string;
}

function ImageUploadInputRetrier({ onClick, children = 'Upload Failed\nClick to Retry', className }: ImageUploadInputRetrierProps) {
  const onKeyUpHandler = useCallback(
    (e: KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'Enter') {
        onClick?.();
      }
    },
    [onClick],
  );

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyUp={onKeyUpHandler}
      className={twMerge('absolute left-0 top-0 flex h-full w-full items-center justify-center bg-red-700/40 text-white', className)}
    >
      <MdRefresh size={12} />
      {children}
    </div>
  );
}

export { ImageUploadInputRetrier };
